'use strict';
var vjs = require('video.js');

vjs.plugin('next', function(opt){
    var player = this;
    player.ready(function(){
        var b, controlBar = player.controlBar;
        b = controlBar.nextVideo = controlBar.addChild('nextButton', opt||{});
        b.on('mouseenter', function(){
            b.addClass('vjs-next-suggestion-show');
            player.trigger('next_suggestion_show');
        });
        b.on('mouseleave', function(){
            b.removeClass('vjs-next-suggestion-show');
            player.trigger('next_suggestion_hide');
        });
    });
});
var events = ['touchstart', 'touchend', 'click'];
var prevent_click = function(event){
    event.stopPropagation();
};
var Button = vjs.getComponent('Button');
vjs.registerComponent('NextButton', vjs.extend(Button, {
    controlText_: 'Next',
    constructor: function(player, options){
        Button.call(this, player, options);
        this.on(events, prevent_click);
    },
    createEl: function(){
        var el = Button.prototype.createEl.apply(this, arguments);
        el.appendChild(vjs.createEl('div', {
            className: 'vjs-button-icon',
            innerHTML: "<svg fill=\"#FFFFFF\" height=\"48\" viewBox=\"0 0 24 24\" width=\"48\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z\"/>\n    <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n</svg>",
        }));
        return el;
    },
    buildCSSClass: function(){
        return 'vjs-next-button '+Button.prototype.buildCSSClass.call(this);
    },
    handleClick: function(event){
        this.player_.trigger('next_suggestion_play'); },
}));
